<template>
	<pagina-erro
		titulo="Desculpe, estamos em manutenção"
		icone="fa fa-cog fa-spin"
		imagemTexto="centralservidor-logo-texto.png"
		imagem="centralservidor-logo.png"
		texto="Estamos fora do ar no momento, mas estamos trabalhando nisso.
			Em breve estaremos operando normalmente." >
	</pagina-erro>
</template>

<script >
import PaginaErro from '@/components/pagina-erro'

export default {
	name: 'Manutencao',
	components: {
		PaginaErro
	}
}
</script>




// WEBPACK FOOTER //
// index.vue?7e659e69